export default function imageNotSave() {
  const protectHandler = event => {
    event.preventDefault();
  };

  $('.wp-block-image, .js-swiper-slide, ._notSave')
    .find('img')
    .each((index, element) => {
      const thisElement = element;

      thisElement.draggable = false;
      $(thisElement).on({
        dragstart: protectHandler,
        contextmenu: protectHandler,
      });
    });
}
